module.exports = __webpack_public_path__ + "assets/logo-classlink.png?ec2ef6a86eabe5dee3ddfbe36d444940"